import _curry2 from "./internal/_curry2.js";
import map from "./map.js";
var lens = _curry2(function lens(getter, setter) {
    return function (toFunctorFn) {
        return function (target) {
            return map(function (focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
export default lens;
